module.exports = __webpack_public_path__ + "img/company2.eb833a43.png";